// ( function() {
// 	var slickBox =require('slick-carousel-browserify');
// 	var $ 	= require('jquery');

// 	var sliderBox = $('.quotes__sliderbox');

// 	// Slick vars
// 	slickVar = {
//   		arrows: false,
// 		infinite:true,
// 		autoplay: true,
//   		mobileFirst: true,
// 		responsive: [{
// 			breakpoint: 768,
// 			settings: {
// 				slidesToScroll: 1,
// 		  		slidesToShow: 1,
// 				centerMode: true,
// 				centerPadding: '100px',
// 			}
// 		}, {
// 			breakpoint: 1200,
// 			settings: {
// 				slidesToScroll: 1,
// 				slidesToShow: 1,
// 				centerMode: true,
// 				centerPadding: '300px',
// 			}
// 		}]
// 	}
// 	 // Function for running slick

// 	 function setSlick() {
// 		 slickBox(sliderBox, slickVar );
// 	 }
// 	 setSlick();

//  	sliderBox.on('destroy', function( event, slick) {
//  		console.log('destroyed');
//  		setSlick();
//  	});

// })();
